import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import workImage from '../assets/images/work_with_me.png';

const WorkWithMe = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={workImage}
                alt="Mayank Sharma"
                className="w-full h-auto object-contain"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:pl-8"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                Work With <span className="gradient-text">Me</span>
              </h2>
              
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                I'm passionate about collaborating on innovative data engineering and cloud projects. 
                Currently working as an Associate Consultant at GlobalLogic, specializing in advanced 
                ETL platforms and data integration solutions.
              </p>
              
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                With expertise in Python, AWS, data engineering, and AI-powered development tools, I bring 
                comprehensive experience in building scalable data pipelines and modern ETL solutions using 
                cutting-edge AI assistance.
              </p>

              {/* Skills Tags */}
              <div className="flex flex-wrap gap-2 mb-8">
                {['Python', 'AWS', 'ETL/ELT', 'Data Pipelines', 'Cursor AI', 'GitHub Copilot', 'Claude', 'Gemini'].map((skill, index) => (
                  <motion.span
                    key={skill}
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.1 * index }}
                    className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium"
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>

              {/* CTA Buttons */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="flex flex-col sm:flex-row gap-4"
              >
                <Link to="/contact" className="btn-primary">
                  Get In Touch
                </Link>
                <Link to="/about" className="btn-secondary">
                  Learn More About Me
                </Link>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WorkWithMe;
